import { useAppContext } from '@/context/AppContext';
import { config } from '@/config';
import styles from './DevBadge.module.css';

/**
 * Floating dev-mode badge that toggles mockup/live mode at runtime.
 * Only rendered when `import.meta.env.DEV` is true (stripped from production builds).
 */
export function DevBadge() {
  if (!import.meta.env.DEV) return null;
  return <DevBadgeInner />;
}

function DevBadgeInner() {
  const { mockupMode, setMockupMode } = useAppContext();

  // Live mode requires a Clerk key; disable toggle if missing
  const clerkAvailable = !!config.clerkPublishableKey;
  const canToggle = mockupMode ? clerkAvailable : true;

  const handleClick = () => {
    if (!canToggle) return;
    if (!mockupMode) {
      setMockupMode(true);
      return;
    }
    // Switching to live requires Clerk
    if (clerkAvailable) {
      setMockupMode(false);
    }
  };

  const label = mockupMode ? 'Mockup' : 'Live';
  const dotClass = mockupMode ? styles.dotMockup : styles.dotLive;
  const badgeClass = canToggle ? styles.badge : `${styles.badge} ${styles.disabledBadge}`;
  const title = canToggle
    ? `Click to switch to ${mockupMode ? 'live' : 'mockup'} mode`
    : 'Live mode requires VITE_CLERK_PUBLISHABLE_KEY';

  return (
    <button type="button" className={badgeClass} onClick={handleClick} title={title}>
      <span className={`${styles.dot} ${dotClass}`} />
      {label}
    </button>
  );
}
